import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CoreModule } from './core/core.module';
import { TestUserComponent } from './features/test-user/test-user.component';
import { HttpInterceptorService } from './core/services/interceptors/http-interceptor.service';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import { ConfirmedemailCallbackComponent } from './features/confirmedemail-callback/confirmedemail-callback.component';
import { HomeComponent } from './features/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SigninCallbackModule } from './features/signin-callback/signin-callback.module';
import { SignoutCallbackModule } from './features/signout-callback/signout-callback/signout-callback.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LayoutModule } from '@angular/cdk/layout';
import { SharedModule } from './shared/shared.module';
import { ViewAllEventsCalendarModule } from './features/view-all-events-calendar/view-all-events-calendar.module';
import {CurrencyPipe, DatePipe, registerLocaleData} from '@angular/common';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import localeItaly from '@angular/common/locales/it';
import localeAustralia from '@angular/common/locales/en-AU';
import localeNorway from '@angular/common/locales/nb';
import localeTurkey from '@angular/common/locales/tr';
import localeUK from '@angular/common/locales/en-GB';
import localeSwitzerland from '@angular/common/locales/de-CH';
import { MatButtonModule } from '@angular/material/button';
import { CourtesyhomeComponent } from './features/courtesy-home/courtesy-home.component';
import {CheckDatePipe} from './shared/custom-pipe/check-date.pipe';
import {VetrinaMesePageModule} from './features/vetrina-mese-page/vetrina-mese-page.module';
import {MonthToStringPipe} from './shared/custom-pipe/month-to-string.pipe';
import { RevokedSessionComponent } from './features/revocked-session/revoked-session.component';
import {DeviceDetectorModule} from 'ngx-device-detector';


registerLocaleData(localeItaly, 'it');
registerLocaleData(localeAustralia, 'en-AU');
registerLocaleData(localeNorway, 'nb');
registerLocaleData(localeTurkey, 'tr');
registerLocaleData(localeUK, 'en-GB');
registerLocaleData(localeSwitzerland, 'de-CH');

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CourtesyhomeComponent,
    TestUserComponent,
    ConfirmedemailCallbackComponent,
    RevokedSessionComponent
  ],
  imports: [
    AppRoutingModule,
    CoreModule,
    SharedModule,
    ViewAllEventsCalendarModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SigninCallbackModule,
    SignoutCallbackModule,
    VetrinaMesePageModule,
    // IMPORTS FOR CALENDAR COMPONENT
    MatNativeDateModule,
    // DIALOG SERVICE IMPORT
    MatSnackBarModule,
    // OTHERS
    LayoutModule,
    MatButtonModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    DeviceDetectorModule.forRoot()
  ],
  exports: [
    ViewAllEventsCalendarModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    DatePipe,
    CheckDatePipe,
    CurrencyPipe,
    MonthToStringPipe,
    {provide: MAT_DATE_LOCALE, useValue: 'it-IT'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
